export default __webpack_public_path__ + "static/media/about-image.5e742189.jpg";